import {COLOR_BRANDING, REFERRER_USER, SET_LANGUAGE, SET_USER_DATA} from './login.actionTypes'
import en from './en.json';


const initialState = {
    user: {} ,
    language: en,
    referrer_user: {},
    client: '',
}



export default function login(state = initialState, action: any) {
    
    switch (action.type) {
        case SET_USER_DATA:{
            return {
                ...state,
                user:action.payload
            };
        }
        case SET_LANGUAGE:{
            return {
                ...state,
                language:action.payload
            };
        }
        case REFERRER_USER:{
            return {
                ...state,
                referrer_user:action.payload
            };
        }
        case COLOR_BRANDING:{
            return {
                ...state,
                client:action.payload
            };
        }
        default:
        return state;

    }

}